import { type ActionEvent, Controller } from "@hotwired/stimulus"

import RecaptchaController from "./recaptcha_controller"

export default class CompetitionFormController extends Controller<HTMLFormElement> {
  static outlets = ["recaptcha"]
  declare readonly recaptchaOutlet: RecaptchaController

  static targets = ["gdprOptInInput", "gdprOptOutInput", "submitButton"]
  declare readonly gdprOptInInputTarget: HTMLInputElement
  declare readonly gdprOptOutInputTarget: HTMLInputElement
  declare readonly submitButtonTarget: HTMLButtonElement

  enableSubmit(): void {
    this.toggleSubmit(true)
  }

  submit(e: ActionEvent): void {
    if (!this.element.checkValidity()) {
      e.preventDefault()
      return
    }

    this.toggleSubmit(false)

    if (!this.recaptchaOutlet.hasToken) {
      e.preventDefault()
      this.recaptchaOutlet.execute()
    }
  }

  handleRecaptchaTokenReceived(): void {
    this.element.requestSubmit()
  }

  toggleGdpr({ currentTarget }: ActionEvent): void {
    const { checked } = currentTarget as HTMLInputElement

    this.gdprOptInInputTarget.disabled = !checked
    this.gdprOptOutInputTarget.disabled = checked
  }

  private toggleSubmit(enabled: boolean): void {
    const { submitButtonTarget } = this
    const icon = submitButtonTarget.querySelector("i[aria-hidden]")!

    submitButtonTarget.disabled = !enabled
    icon.classList.toggle("fa-spinner", !enabled)
    icon.classList.toggle("fa-spin", !enabled)
  }
}
